
import { useContext } from '@nuxtjs/composition-api'
import useCheckout from '@/composable/checkout/useCheckout'

export default {
  name: 'TlmCheckoutMenuPanel',
  props: {
    contextName: {
      type: String,
      default: '',
      required: true
    },
    items: {
      type: Array,
      default: () => []
    },
    trackingEvent: {
      type: String,
      default: 'customerTypeClick'
    }
  },
  setup (props) {
    const { app } = useContext()
    const { state } = useCheckout(app)
    const context = state[props.contextName]

    const { menu } = context
    const menuItems = context.menuItems || props.items

    return {
      menuItems,
      menu
    }
  }
}
